<template>
  <div class="banner">
	 <div class="imgcar">
		 <div class="car_two">
		 	 <img class="twoimg" src="../../static/index/emblem_two@2x.png" alt="" @click="refresh"/>
		 </div>
			<div class="car_one">
				<img class="oneimg" src="../../static/index/emblem@2x.png" alt="" @click="refresh"/>
			</div>
	 </div>
	
	 
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  
  methods: {
	  refresh(){
		this.$router.go(0)  
	  }
	  
  }
  
};
</script>

<style lang="scss" scoped>

.banner {
	// background: #FFFFFF;
	// // background: url(../../static/index/back_top.png) no-repeat center / 100%;
	// background: url(../../static/index/back_top.png);
	// background-size: 100% 100%;
	// // height: 100%;
	// height: 875px;
	// width: 100%;
	
	.imgcar{
		position: absolute;
		margin: 0.4rem auto;
		margin-left: -0.5rem;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		.car_one{
			margin-left: 3rem;
			.oneimg{
				height:0.46rem;
				width:4.4rem;
			}
		}
		.car_two{
			.twoimg{
				height:1rem;
				width:3.6rem;
				
			}
		}
	}
	
	
	// .imgcar{
	// 	position: absolute;
	// 	margin: 0.1rem auto;
	// 	margin-left: -0.7rem;
	// 	width: 100%;
	// 	display: flex;
	// 	justify-content: center;
	// 	align-items: center;
	// 	.car_one{
	// 		margin-left: 3rem;
	// 		.oneimg{
	// 			height:46px;
	// 			width:4.4rem;
	// 		}
	// 	}
	// 	.car_two{
	// 		.twoimg{
	// 			height:110px;
	// 			width:3.9rem;
				
	// 		}
	// 	}
	// }
	
	
}
</style>
